import React from 'react';

function money(value) {
  const amount = Number(value || 0);
  return amount ? `Rs ${amount.toLocaleString()}` : '';
}

export function AdvanceTag({ status, amount = 0, hasAttachment = false }) {
  const key = String(status || '').toLowerCase();
  if (key.includes('pay on arrival')) {
    return <span className="advance-tag pay-arrival">Pay on Arrival</span>;
  }
  if (key.includes('waived')) {
    return <span className="advance-tag waived">Advance Waived</span>;
  }
  if (!Number(amount || 0)) return null;
  const cls = hasAttachment ? 'complete' : 'missing';
  const label = hasAttachment ? `${money(amount)} attached` : `${money(amount)} missing screenshot`;
  return <span className={`advance-tag ${cls}`}>{label}</span>;
}
